module.exports = __webpack_public_path__ + "img/Fire.abe4e25b.svg";